import { Box, Button, Grid, Typography, Checkbox } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { InputMask, InputText, Modal } from "src/components";
import { Save as SaveIcon, Cancel as CancelIcon } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  loadDeliveryConfig,
  saveDeliveryConfig,
} from "src/store/actions/delivery";

const FORM_CONFIGURACOES_SCHEMA = {
  id: 0,
  limite_area_km: "",
  tempo_medio_entrega: "",
  tipo_frete: "K",
  tipo_layout: "D",
  tipo_limite_area: "K",
  valor_frete_fixo: 0,
  valor_frete_variavel: 0,
  valor_pedido_minimo: 0,
  pagto_pelo_app: false,
  pagto_pelo_app_id: "",
  valor_compra_min_frete: 0,
  valor_pedido_minimo: 0
};

function ModalConfiguracoes({ open, close }) {
  const [formConfiguracoes, setFormConfiguracoes] = useState(
    FORM_CONFIGURACOES_SCHEMA
  );

  const { delivery_configuracao } = useSelector((state) => state.delivery);
  const { modulos } = useSelector((state) => state.menus);
  const dispatch = useDispatch();

  useEffect(() => {
    if (delivery_configuracao) {
      setFormConfiguracoes({
        ...FORM_CONFIGURACOES_SCHEMA,
        ...delivery_configuracao,
        pagto_pelo_app:
          delivery_configuracao.pagto_pelo_app === "S" ? true : false,
      });
    } else {
      setFormConfiguracoes(FORM_CONFIGURACOES_SCHEMA);
    }
  }, [delivery_configuracao]);

  useEffect(() => {
    dispatch(loadDeliveryConfig());
  }, [dispatch]);

  const handleChange = (event) => {
    setFormConfiguracoes({
      ...formConfiguracoes,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async () => {
    await saveDeliveryConfig({
      ...formConfiguracoes,
      pagto_pelo_app: formConfiguracoes.pagto_pelo_app ? "S" : "N",
    });
    close();
  };

  //4 é o id do módulo de pagamento
  const opcoesFinanceiro = () =>
    modulos.find((item) => (item.modulo_id === 4 ? true : false));

  return (
    <Modal style={{ maxWidth: "700px" }} open={open}>
      <Typography> Configurações de delivery </Typography>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <InputText
              name="tipo_frete"
              value={formConfiguracoes.tipo_frete}
              select
              label="Tipo de frete"
              margin="dense"
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
            >
              {/* F=FIXO, K=KM, V=KMV "KILOMETRO * PERCENTUAL VALOR" G="FIXO + GRATIS"*/}
              <option value="K"> VALOR POR KM </option>
              <option value="F"> VALOR FIXO </option>
              <option value="V"> KM + % DO VALOR</option>
              <option value="G"> VALOR FIXO + GRATIS </option>
            </InputText>
          </Grid>

          <Grid item sm={4}>
            <TextValidator
              fullWidth
              margin="dense"
              name="tempo_medio_entrega"
              label="Tempo de entrega (MIN)"
              value={formConfiguracoes.tempo_medio_entrega}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid item sm={4}>
            <InputMask
              label="Valor do frete fixo"
              type="cash"
              value={formConfiguracoes.valor_frete_fixo}
              onChange={(e) =>
                setFormConfiguracoes({
                  ...formConfiguracoes,
                  valor_frete_fixo: e.target.values.floatValue,
                })
              }
            />
          </Grid>

          {formConfiguracoes.tipo_frete == "G" && (
            <Grid item sm={4}>
              <InputMask
                label="R$ Compra"
                type="cash"
                value={formConfiguracoes.valor_compra_min}
                onChange={(e) =>
                  setFormConfiguracoes({
                    ...formConfiguracoes,
                    valor_compra_min: e.target.values.floatValue,
                  })
                }
              />
            </Grid>
          )}

          {(formConfiguracoes.tipo_frete == "K" || formConfiguracoes.tipo_frete == "V") && (
          <Grid item sm={4}>
            <InputMask
              label="Valor do frete por KM"
              type="cash"
              value={formConfiguracoes.valor_frete_variavel}
              onChange={(e) =>
                setFormConfiguracoes({
                  ...formConfiguracoes,
                  valor_frete_variavel: e.target.values.floatValue,
                })
              }
            />
          </Grid>
          )}

          <Grid item sm={4}>
            <InputMask
              label="Valor Pedido Mínimo"
              type="cash"
              value={formConfiguracoes.valor_pedido_minimo}
              onChange={(e) =>
                setFormConfiguracoes({
                  ...formConfiguracoes,
                  valor_pedido_minimo: e.target.values.floatValue,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <InputText
              name="tipo_limite_area"
              value={formConfiguracoes.tipo_limite_area}
              select
              label="Tipo limite da área"
              margin="dense"
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
            >
              <option value="K"> KM </option>
              <option value="C"> Cidade </option>
              <option value="E"> Estado </option>
              <option value="N"> País </option>
            </InputText>
          </Grid>
          <Grid item sm={4}>
            <TextValidator
              fullWidth
              margin="dense"
              name="limite_area_km"
              label="Limite da área (KM)"
              value={formConfiguracoes.limite_area_km}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>
          <Grid style={{ display: "flex", alignItems: "center" }} item sm={3}>
            <Typography color="textSecondary">Alerta sonoro?</Typography>
            <Checkbox
              color="primary"
              checked={Boolean(formConfiguracoes.alerta_sonoro)}
              onChange={(e) =>
                setFormConfiguracoes({
                  ...formConfiguracoes,
                  alerta_sonoro: e.target.checked,
                })
              }
            />
          </Grid>
          {opcoesFinanceiro() && (
            <Grid container item sm={9}>
              <Grid
                style={{ display: "flex", alignItems: "center" }}
                item
                sm={6}
              >
                <Typography color="textSecondary">
                  Pagamento pelo app?
                </Typography>
                <Checkbox
                  color="primary"
                  checked={formConfiguracoes.pagto_pelo_app}
                  onChange={(e) => {
                    setFormConfiguracoes({
                      ...formConfiguracoes,
                      pagto_pelo_app: e.target.checked,
                    });
                  }}
                />
              </Grid>
              <Grid item sm={6}>
                <TextValidator
                  fullWidth
                  margin="dense"
                  name="pagto_pelo_app_id"
                  label="Cód da empresa (Conexo Pay)"
                  value={formConfiguracoes.pagto_pelo_app_id}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Box display="flex" justifyContent="flex-end" marginTop="8px">
          <Button type="submit" color="primary" size="small">
            {<SaveIcon />}&nbsp;Gravar
          </Button>
          <Button color="secondary" size="small" onClick={close}>
            {<CancelIcon />}&nbsp;Cancelar
          </Button>
        </Box>
      </ValidatorForm>
    </Modal>
  );
}

export default ModalConfiguracoes;
